import { render } from "./AlarmCreate.vue?vue&type=template&id=3c31311a"
import script from "./AlarmCreate.vue?vue&type=script&lang=js"
export * from "./AlarmCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__